function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}
  
function slist (target) {
    target.classList.add("slist");

    let items = target.getElementsByTagName("li"), current = null;

    if(items.length === 0){
        toggle('hfs-spinner', 'none');
    }

    // (B) MAKE ITEMS DRAGGABLE + SORTABLE
    for (let i of items) {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;
        
        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.ondragstart = (ev) => {
        current = i;
        for (let it of items) {
            if (it != current) { it.classList.add("hint"); }
        }
        };
        
        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.ondragenter = (ev) => {
        if (i != current) { i.classList.add("active"); }
        };

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.ondragleave = () => {
        i.classList.remove("active");
        };

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.ondragend = () => { for (let it of items) {
            it.classList.remove("hint");
            it.classList.remove("active");
        }};

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.ondragover = (evt) => { evt.preventDefault(); };

        // (B7) ON DROP - DO SOMETHING
        i.ondrop = (evt) => {
        evt.preventDefault();
        if (i != current) {
            let currentpos = 0, droppedpos = 0;
            for (let it=0; it<items.length; it++) {
            if (current == items[it]) { currentpos = it; }
            if (i == items[it]) { droppedpos = it; }
            }
            if (currentpos < droppedpos) {
            i.parentNode.insertBefore(current, i.nextSibling);
            } else {
            i.parentNode.insertBefore(current, i);
            }
        }
        };
        toggle('hfs-spinner', 'none');
        target.classList.add("show");
    }
}

/**
 * Sorting list for images
 */
 if(document.getElementById("sortlist") !== null){
    slist(document.getElementById("sortlist"));
}
if(document.getElementById("sortlist2") !== null){
    slist(document.getElementById("sortlist2"));
}